import React from "react";

import { useEnumeratedDataTable } from "redux/features/enumeratedDataValues";
import SimpleSelect from "util/simpleSelect";

function DisabilityComponent({ getValue, setValue, forSummary, RenderField }) {
  const { list: booleans, lookup: booleanLookup } = useEnumeratedDataTable(
    "optional_boolean_values"
  );
  const currentValue = getValue("disability_id");
  return (
    <RenderField
      label="Disability?"
      question="Do you live with a disability, physical or otherwise?"
      value={currentValue}
      valueLookup={booleanLookup}
    >
      <SimpleSelect
        currentValue={currentValue}
        setValue={(newId) => setValue("disability_id", newId)}
        valueObjects={booleans}
        alwaysNumeric
      />
    </RenderField>
  );
}

export default DisabilityComponent;
